import { render, staticRenderFns } from "./AdminManualPaymentsList.vue?vue&type=template&id=51f456cc&scoped=true"
import script from "./AdminManualPaymentsList.vue?vue&type=script&lang=js"
export * from "./AdminManualPaymentsList.vue?vue&type=script&lang=js"
import style0 from "./AdminManualPaymentsList.vue?vue&type=style&index=0&id=51f456cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f456cc",
  null
  
)

export default component.exports